import { useEffect, useState } from "react"
import { Grid, Card, CardContent, CardActions, Button } from "@material-ui/core"
import CbAgentes from "./CbAgentes"
import { useSelector, useDispatch } from "react-redux"
import { getReporteCotizacionesAgenteMes } from "../../../services/cotizacionService"
import { FormatoFecha } from "../../../utils/FormatFecha"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import GraficaBarrasGlobal from "./Grafica"
import { dataGraficarCotizacionesAgente } from "./utils/dataGraficar"
import { agregarAgentesLista } from "../../../ducks/reportesCotizacionesDuck"
import FiltroMes from "./FiltroMes"
const useConsultaAgenteCotizacionMes = ({ idAgente }) => {
    const { agenteMes } = useSelector(store => store.reporteCotizador)
    const dispatch = useDispatch()
    const [data, setData] = useState([])
    const [load, setLoad] = useState(false)
    useEffect(() => {
        async function fetchData() {
            dispatch(onLoadAnction({ message: "" }))
            setLoad(true)
            await getReporteCotizacionesAgenteMes({ Fecha: FormatoFecha({ date: agenteMes, formato: "MMyyyy" }), IdAgente: idAgente }).then(Response => {
                setData(Response)
            }).catch(Error => {
                setData([])
            }).finally(() => {
                setLoad(false)
                dispatch(offLoadAction())
            })
        }
        fetchData()
    }, [dispatch, idAgente, agenteMes])
    return { data, load }
}
const CardAgente = ({ agente }) => {
    const { data, load } = useConsultaAgenteCotizacionMes({ idAgente: agente.UserId })
    const { agenteMes, agentesSeleccionados } = useSelector(store => store.reporteCotizador)
    const dispatch = useDispatch()
    const handleClick = () => {
        const newAgentesSeleccionados = [...agentesSeleccionados]
        const findAgente = newAgentesSeleccionados.findIndex(agente => agente.UserId === agente.UserId)
        if (findAgente < 0) {
            return null
        }
        const newArrray = newAgentesSeleccionados.filter((agente, index) => {
            if (index !== findAgente) {
                return agente
            }
        })
        dispatch(agregarAgentesLista({ newAgentes: newArrray }))
    }
    return (
        <Grid item xs={4}>
            <Card style={{ minHeight: "430px" }}>
                {
                    (load) ? <CardContent><p>Obteneido información</p></CardContent> :
                        <CardContent>
                            <b>Agente:</b>
                            {
                                ` ${agente.Nombres} ${agente.ApellidoPaterno} ${agente.ApellidoMaterno}`
                            }
                            <br />
                            {
                                `${agente.Email}`

                            }
                            <br />
                            Total de cotizacion del agente: {agente.lDetalleCotizacion?.reduce((a, b) => a + b.total, 0)}
                            <br />
                            {
                                data?.sort((a, b) => {
                                    return a.catEstatusCotizacion?.IdCatEstatusCotizacion - b.catEstatusCotizacion?.IdCatEstatusCotizacion
                                }).map(cotizacion => {
                                    return (
                                        <div key={cotizacion?.catEstatusCotizacion?.IdCatEstatusCotizacion}>
                                            {`${cotizacion?.catEstatusCotizacion?.Descripcion}: ${cotizacion?.total}`}
                                        </div>
                                    )
                                })
                            }
                            <GraficaBarrasGlobal data={dataGraficarCotizacionesAgente({ cotizacionesAgente: data, fecha: agenteMes })} />
                        </CardContent>
                }

                <CardActions style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Button onClick={handleClick} variant="contained" color="primary">Quitar</Button>
                </CardActions>
            </Card>
        </Grid>
    )
}
const CotizacionesAgenteMes = () => {
    const { agentesSeleccionados } = useSelector(store => store.reporteCotizador)
    return (
        <>
            <Grid container style={{ margin: "1rem 0" }} alignItems="center" justifyContent="center" spacing={1}>
                <Grid item xs={4}>
                    <CbAgentes />
                </Grid>
                <Grid item xs={4}>
                    <FiltroMes />
                </Grid>
            </Grid>
            <Grid container style={{ marginBottom: "1rem" }} alignItems="flex-start" justifyContent="center" spacing={1}>
                {
                    agentesSeleccionados?.map(item => {
                        return (
                            <CardAgente key={item.UserId} agente={item} />
                        )
                    })
                }
            </Grid>
        </>
    )
}
export default CotizacionesAgenteMes